import React, { useState } from "react";
import { Button, Input, Textarea, Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";

const Contact = ({ handleOpen }) => {
  const [t] = useTranslation();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const subject = encodeURIComponent("New Contact Form Submission");
    const body = encodeURIComponent(`
First Name: ${formData.firstName}
Last Name: ${formData.lastName}
Email: ${formData.email}
Message: ${formData.message}
    `);

    window.location.href = `mailto:kapango@konnectacademy.com?subject=${subject}&body=${body}`;
  };

  return (
    <section className="px-8 py-8 lg:py-16">
      <div className="container mx-auto text-center">
        <Typography
          variant="h5"
          color="blue-gray"
          className="mb-4 !text-base lg:!text-2xl"
        >
          {t(`form_header`)}
        </Typography>
        <Typography
          variant="h1"
          color="blue-gray"
          className="mb-4 !text-3xl lg:!text-5xl"
        >
          {t(`form_subheader`)}
        </Typography>
        <Typography className="mb-10 font-normal !text-lg lg:mb-20 mx-auto max-w-3xl !text-gray-500">
          {t(`form_content`)}
        </Typography>
        <div>
          <form onSubmit={handleSubmit} className="flex flex-col">
            <div className="grid grid-cols-2 gap-4">
              <div className="py-1">
                <Typography
                  variant="small"
                  className="mb-2 text-left font-medium !text-gray-900"
                >
                  {t(`contact_form.first_name`)}
                </Typography>
                <Input
                  color="gray"
                  size="lg"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="focus:border-t-gray-900"
                  containerProps={{
                    className: "min-w-full",
                  }}
                  labelProps={{
                    className: "hidden",
                  }}
                />
              </div>
              <div className="py-1">
                <Typography
                  variant="small"
                  className="mb-2 text-left font-medium !text-gray-900"
                >
                  {t(`contact_form.last_name`)}
                </Typography>
                <Input
                  color="gray"
                  size="lg"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="focus:border-t-gray-900"
                  containerProps={{
                    className: "!min-w-full",
                  }}
                  labelProps={{
                    className: "hidden",
                  }}
                />
              </div>
            </div>
            <div className="py-1">
              <Typography
                variant="small"
                className="mb-2 text-left font-medium !text-gray-900"
              >
                {t(`contact_form.email`)}
              </Typography>
              <Input
                color="gray"
                size="lg"
                placeholder="name@email.com"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="focus:border-t-gray-900"
                containerProps={{
                  className: "!min-w-full",
                }}
                labelProps={{
                  className: "hidden",
                }}
              />
            </div>
            <div className="py-1">
              <Typography
                variant="small"
                className="mb-2 text-left font-medium !text-gray-900"
              >
                {t(`contact_form.content`)}
              </Typography>
              <Textarea
                rows={6}
                color="gray"
                placeholder="Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="focus:border-t-gray-900"
                containerProps={{
                  className: "!min-w-full",
                }}
                labelProps={{
                  className: "hidden",
                }}
              />
            </div>
            <div className="grid grid-cols-2 gap-6">
              <Button
                onClick={handleOpen}
                className="w-full border border-red-300 bg-transparent text-red-400"
                color="gray"
              >
                {t(`contact_form.cancel`)}
              </Button>
              <Button type="submit" className="w-full bg-red-400" color="gray">
                {t(`contact_form.confirm`)}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
